
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const adresses = state => state.adresses;
const getsingle = state => param =>state.adresses.find((a)=> a.id == param)

export default {
  formdata,
  data,
  adresses,
  dataobject,
  getsingle
};